import Routes from 'apps/portal/routes.erb';
import ajax from 'helpers/ajax';
import types from './action-types';

export function loadOpenings(payload) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_OPENINGS, payload });

    const config = {
      url: Routes.directory_openings_path(payload.accountSlug, {
        brand_slug: payload.brandSlug,
        country_code: payload.countryCode,
        location_external_id: payload.locationExternalId,
        format: 'json',
      }),
      params: payload.params,
    };

    ajax(config, types.LOAD_OPENINGS)
      .then(response => dispatch({ type: types.LOAD_OPENINGS_RESULT, payload: response.data }))
      .catch(() => dispatch({ type: types.LOAD_OPENINGS_RESULT, error: true }));
  };
}
